<template>
  <div v-if="popupVisible">
    <side-popup :title="title" :popupVisible="popupVisible" width="1500px" @onClose="onClose">
      <div class="w1500P75">
        <!-- <div class="href-box">
          <div class="a-box flex flex-ac">
            <swiper ref="mySwiper" class="index-swiper" :options="hrefOptions">
              <swiper-slide class="href-slide">
                <a class="a-item" :class="{'a-item-active':-1==searchForm.index}" @click="scrollToAnchor(-1)">
                  <div class="n">全部</div>
                </a>
              </swiper-slide>
              <swiper-slide v-for="(typeItem,index) in typeBoxList" :key="typeItem.id" class="href-slide">
                <a class="a-item" :class="{'a-item-active':index==searchForm.index}" @click="scrollToAnchor(index)">
                  <div class="n">{{ typeItem.type_name }}</div>
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div class="search-input flex flex-ac">
            <span class="label">价格</span>
            <input v-model="searchForm.minPrice" placeholder="请输入价格" class="input-price" />
            <span class="split">~</span>
            <input v-model="searchForm.maxPrice" placeholder="请输入价格" class="input-price" />
            <div class="btn-yellow" @click="getData">查询</div>
          </div>
        </div> -->
        <div v-if="!showDetail" class="csgo-box1">
          <ul class="flex flex-w flex-jc">
            <li v-for="item in list" :key="item.id" class="box-hover">
              <div class="li-div">
                <div class="bei1">
                  <img :src="item.img_main" class="img_main" />
                  <img :src="item.img_active" class="img_active" />
                </div>
                <div class="name">{{ item.name }}</div>
                <div class="money-warp flex flex-jc flex-ac">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ item.price }}</span>
                </div>
                <div v-if="item.num===0" class="add-btn choose-case-btn-add" @click="add(item,1)">添加箱子</div>
                <div v-else class="add-num flex flex-ac flex-jsb" style="margin: 0 auto;">
                  <img src="@/assets/images/jian.png" alt="" srcset="" @click="add(item,-1)">
                  <div class="num">{{ item.num }}</div>
                  <img src="@/assets/images/add.png" alt="" srcset="" @click="add(item,1)">
                </div>
                <div class="li-div-detail">
                  <i class="el-icon-info" @click="getBoxInfo(item)" />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-else class="revisionSkin">
          <ul>
            <li v-for="item in skin_list" :key="item.id" class="skin-li" :class="parseColor(item,'price_box','key',price)">
              <div class="li-div li-div-center">
                <span v-if="item.exteriorName" class="ico">{{ item.exteriorName }}</span>
                <div class="rate">{{ item.probability }}%</div>
                <div class="bei">
                  <img :src="item.img" class="img_active" />
                </div>
                <div class="name p-1">{{ item.name }}</div>
                <div class="money-warp">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ item.price }}</span>
                </div>
                <div class="color-line" :style="'background-color:'+parseColor(item,'price_box','color',price)"></div>
              </div>
            </li>
          </ul>
          <div v-if="skin_list.length===0" class="no-data">
            <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
            <div class="text">暂无任何数据哦~</div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding: 10px 0;">
        <div class="flex flex-ac flex-jc">
          <div v-if="showDetail" class="money-warp flex flex-ac" style="color: #FFC400;margin-right: 10px;">
            <img src="@/assets/images/money.png" class="money-img" />
            <span>{{ price }}</span>
          </div>
          <div @click="onClose" class="btn">确认</div>
        </div>

      </div>
    </side-popup>
  </div>
</template>

<script>
import SidePopup from "@/g-components/side-black-popup.vue";
import empty from "@/g-components/empty.vue";
import { parseColor } from "@/assets/js/util.js";

export default {
  components: {
    SidePopup,
    empty
  },
  data() {
    return {
      parseColor,
      // box 选择箱子 也可查看箱子的饰品
      selType: 'box',
      title: '选择指定盲盒',
      box: {
        name: '',
        skin_list: [],
        content: ''
      },
      hrefOptions: {
        slidesPerView: 'auto'
      },
      list: [],
      searchForm: {
        minPrice: '',
        maxPrice: '',
        index: -1,
        type: 'fight'
      },
      typeBoxList: [],
      skin_list: [],
      showDetail: false,
      popupVisible: false,
      price: 0,
      num: 0 // 当前弹窗内选中的总数量
    }
  },
  created() { },
  methods: {
    // [新增] 辅助方法：根据当前 list 计算总数量
    calculateTotalNum() {
      let total = 0;
      this.list.forEach(item => {
        total += (item.num || 0);
      });
      this.num = total;
    },

    onClose() {
      if (this.showDetail) {
        if (this.selType == 'box') {
          this.title = '选择指定盲盒'
          this.showDetail = false
          return false
        } else {
          this.popupVisible = false
          this.showDetail = false
          return false
        }

      }
      this.popupVisible = false;
      // 过滤出选中的物品返回给父组件
      let selList = this.list.filter(item => item.num > 0);
      this.$emit('onClose', selList);
    },

    add(item, type) {
      if (type == 1) {
        // [修复1] 使用实时计算的总数进行判断，或者确保 this.num 是准确的
        // 这里为了保险，先判断 this.num (假设它时刻保持同步)
        if (this.num >= 6) {
          this.$message.error('最多只能选择6个商品');
          return false;
        }
        item.num = (item.num || 0) + 1;
        this.num++;
      } else {
        // [修复4] 防止减到负数
        if (item.num > 0) {
          item.num--;
          this.num--;
        }
      }
      this.$forceUpdate();
      // [修复3] 移除 $forceUpdate，Vue 响应式应该能处理 item.num 的变化
      // 如果视图确实不更新，请检查 item 对象是否是响应式的（在 getData 中已确保）
    },

    toggle(data, selType) {
      this.selType = selType || 'box'
      this.popupVisible = false
      if (selType === 'box') {
        this.title = '选择指定盲盒'
        this.getData(data)
      } else {
        this.showDetail = true
        this.getBoxInfo(data)
      }
    },

    scrollToAnchor(index) {
      if (this.searchForm.index === index) {
        return false;
      }
      this.searchForm.index = index;

      // [修复2] 重构列表生成逻辑，避免数据重复
      if (index === -1) {
        let allList = [];
        this.typeBoxList.forEach(item => {
          if (item.box_list && Array.isArray(item.box_list)) {
            allList = allList.concat(item.box_list);
          }
        });
        this.list = allList;
      } else {
        if (this.typeBoxList[index] && this.typeBoxList[index].box_list) {
          this.list = this.typeBoxList[index].box_list;
        } else {
          this.list = [];
        }
      }

      // [重要] 切换列表后，必须重新计算当前已选总数
      // 因为 list 变了，item.num 的状态被保留在新列表中，需要重新统计
      this.calculateTotalNum();
    },

    getData(selectList) {
      let ids = selectList.map(item => item.id);
      this.$doGet("/api/hall.Box/list", this.searchForm).then((res) => {
        this.typeBoxList = res.data || [];
        this.list = [];

        // 构建列表并恢复选中状态
        res.data.forEach(item => {
          if (item.box_list && Array.isArray(item.box_list)) {
            item.box_list.forEach(v => {
              let index = ids.indexOf(v.id);
              // 恢复之前选中的数量，如果没有选中则为 0
              v.num = index === -1 ? 0 : selectList[index].num;
            });
            this.list = this.list.concat(item.box_list);
          }
        });

        // [修复1] 数据加载完成后，立即计算初始的总数量
        this.calculateTotalNum();

        this.popupVisible = true
      }).catch(() => { });
    },
    getBoxInfo(item) {
      let param = {
        box_id: item.id,
      }
      this.price = item.price
      this.skin_list = []
      this.showDetail = true
      this.title = '盲盒中的饰品'
      this.$doGet("/api/hall.Box/info", param).then((res) => {
        // res.data.box_skins 根据价格倒序排序下
        res.data.box_skins.sort((a, b) => b.price - a.price)
        this.skin_list = res.data.box_skins
        this.popupVisible = true
      }).catch(() => { })
    },
  }
};
</script>

<style lang="less" scoped>
.btn {
  width: 150px;
  background-color: #ffc400;
  border: 0;
  color: #1a1c24;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  line-height: 40px;
  border-radius: 4px;
  cursor: pointer;
}
.href-box {
  height: 60px;
  background: #2b2e3c;
  // padding: 0 30px;
  color: #fff;
  font-size: 15px;
  position: relative;
  &.href-box-f {
    width: 100%;
    position: fixed;
    top: 72px;
    left: 0;
    z-index: 22;
  }
  .a-box {
    max-width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    white-space: nowrap;
    .href-slide {
      width: auto;
    }
  }
  .a-item {
    line-height: 60px;
    display: inline-block;
    padding: 0px 10px;
    position: relative;
    color: #fff;
    &.a-item-active {
      color: #ffc400;
    }
    &.a-item-active::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background: #ffc400;
      bottom: 0;
      left: 0px;
    }
    .n {
      display: inline-block;
    }
  }
  .search-input {
    padding-right: 30px;
    min-width: 370px;
    .input-price {
      width: 100px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      line-height: 24px;
      border: 0;
    }
    .label {
      margin-right: 12px;
    }
    .btn-yellow {
      margin-left: 24px;
    }
    .split {
      margin: 0 8px;
    }
  }
}
.no-data {
  padding: 100px 0;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  img {
    width: 182px;
    margin-bottom: 10px;
  }
}
</style>